import { AccountLoadStatus } from "../WithAccounts/WithAccounts";
import useAccount from "assets/scripts/hooks/useAccount";
export { AccountLoadStatus };
const WithAccount = ({ acctId, children }) => {
    const acct = useAccount(acctId);
    return children(acct);
};
export default WithAccount;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/WithAccounts/WithAccount.tsx